// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message__9WzC8","error":"Message_error__yaGNX","success":"Message_success__oEb_B","warning":"Message_warning__GFTrr"};